// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Recurring Payments',
  subtitle: 'Manage all invoices',
  newPayment: 'New Payment',
  exportToExcel: 'Export',
  connectorInfo: 'Payment connector is established through the company.',
  addNewPayment: 'Add New Recurring Payment',
  editPayment: 'Edit Recurring Payment',
  packageName: 'Package Name',
  packageType: 'Package Type',
  purchasePrice: 'Purchase Price',
  salePrice: 'Sale Price',
  frequency: 'Frequency',
  startDate: 'Start Date',
  nextPayment: 'Next Payment Date',
  paymentProbability: 'Payment Probability',
  probability: 'Payment Probability',
  profit: 'Profit',
  allCompanies: 'All Companies',
  groupByCompany: 'Group by Company',
  totalPurchase: 'Total Purchase',
  totalSale: 'Total Sale',
  totalProfitLoss: 'Total Profit/Loss',
  paymentCount: 'payments',
  extendPeriod: 'Extend Period',
  confirmExtend: 'Do you want to extend the period?',
  extendedSuccess: 'Period successfully extended',
  extendError: 'Period could not be extended',
  deleteConfirm: 'Do you want to delete this payment?',
  paymentDeleted: 'Recurring payment successfully deleted',
  paymentAdded: 'Recurring payment successfully added',
  paymentUpdated: 'Recurring payment successfully updated',
  deleteError: 'Recurring payment could not be deleted',
  noPayments: 'No recurring payments yet',
  noPaymentsDesc: 'Start by adding your first recurring payment.',
  noFilterResults: 'No payments found matching the filter',
  noFilterResultsDesc: 'Select a different company or clear the filter.',
  selectCompany: 'Select company',
  selectDomain: 'Select domain',
  noDomainsFound: 'No domains found for this company',
  selectHosting: 'Select Hosting Package',
  manualEntry: 'Manual entry',
  noHostingPrices: 'Hosting price not defined',
  packagePlaceholder: 'Ex: Domain Package',
  getHostingPrice: 'Price',
  getDomainPrice: 'Price',
  whoisLookup: 'WHOIS',
  whoisTitle: 'Fetch dates from WHOIS',
  domainPriceTitle: 'Get domain price',
  hostingPriceTitle: 'Get hosting price',
  notes: 'Notes',
  notesPlaceholder: 'Additional notes...',
  cancel: 'Cancel',
  addPayment: 'Add Payment',
  update: 'Update',
  paymentProbabilityPlaceholder: '100',
  paymentProbabilityHint: 'Between 0-100',
  selectDomainFirst: 'Please select a domain first',
  domainInfoNotFound: 'Domain information not found',
  whoisLoading: 'Querying WHOIS information...',
  whoisError: 'WHOIS information could not be retrieved',
  whoisParseError: 'WHOIS data could not be parsed.',
  whoisNoDate: 'No date information found in WHOIS data.',
  whoisSuccess: 'WHOIS information successfully retrieved',
  domainExtensionError: 'Domain extension could not be extracted',
  domainPriceNotFound: 'Price not defined for this extension',
  domainPriceSuccess: 'Domain price successfully retrieved',
  domainPriceError: 'Domain price could not be retrieved',
  hostingPriceSuccess: 'Hosting price successfully retrieved',
  hostingPriceSuccessAuto: 'Hosting price automatically retrieved',
  hostingPriceNotFound: 'Price not defined.',
  hostingPriceError: 'Hosting price could not be retrieved',
  enterPackageName: 'Please enter package name first',
  exportSuccess: 'Recurring payments successfully exported',
  typeDomain: 'Domain',
  typeHosting: 'Hosting',
  typeSsl: 'SSL',
  typeEmail: 'E-mail',
  typeReklam: 'Advertisement',
  typeDanismanlik: 'Consulting',
  typeOther: 'Other',
  freqMonthly: 'Monthly',
  freqYearly: 'Yearly',
  freqOneTime: 'One Time',
  statusActive: 'Active',
  statusPassive: 'Passive',
  daysLeft: 'days left',
  daysPast: 'days past',
  overdue: 'Overdue',
  today: 'Today',
  nA: 'N/A',
  editTitle: 'Edit',
  deleteTitle: 'Delete',
  extendTitle: 'Extend Period',
  oneMonth: 'One month',
  oneYear: 'One year',
  hostingPackagesError: 'Hosting packages could not be loaded',
  domainsLoadError: 'Domains could not be loaded',
  fetchError: 'Data could not be retrieved',
  exchangeRateError: 'Exchange rate information could not be retrieved'
};
